// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_q6E","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_hLY StatelessWorkCardsUpsellModal-styles-cls1_q6E"};